import store from '@/store'
import {getWeightData, formatWeightData, analysisWeightFromString} from "@/libs/util";
import {queryAllSkus} from '@/api/sorting/sorting'
import {queryAdminConfig, queryDeliverySetting, queryOperationList} from "@/api/system/settings";
import {querySupplierList,} from '@/api/user/user'
import {queryTurnoverBoxList} from "@/api/sorting/turnoverBox"
// import {changeUnit} from "@/libs/util";

export default {
	async initChromeApp(context, param) {
		let weightSerial = localStorage.getItem("weightSerial");
		console.log("weightSerial:", weightSerial)
		if (weightSerial) {
			try {
				let port = chrome.runtime.connect(weightSerial, {name: "tochrome"});
				console.log("port", port)
				port.postMessage({data: "data"});
				context.commit("openChromeApp", true);
				port.onMessage.addListener((value) => {
					// console.log(value)
					// if (value.value == "+")
					// 	return;
					// if (value.code == 'value') {
					// 	let realWeight = analysisWeightFromString(value.value);
					// 	let event = new CustomEvent("weightCall", {detail: {weight: realWeight}});
					// 	// console.log("电子秤返回数据", value, "处理后的重量,如果处理后数据有异常去util.js方法里调试", realWeight);
					// 	window.dispatchEvent(event);
					// }
					// console.log("称重监听", value)
					let weightAgreement = localStorage.getItem("weightAgreement"); // 电子秤协议
					if (value.version && value.version == "v2") { // 新版
						getWeightData(value.data, weightAgreement)
					} else {
						formatWeightData(value.value)
					}
				});
				return true;
			} catch (e) {
				console.log(e, "电子秤设备检测报错");
				return "电子秤连接失败";
			}
		} else {
			/*this.$Notice.error({
				title: "请先设置电子秤ID",
			});*/
			return "请先设置电子秤ID";
		}
	},
	// 查询所有sku对应cover
	initAllSkuCover(context) {
		return new Promise((resolve, reject) => {
			queryAllSkus().then(res => {
				if (res.status === 200) {
					let skuList = res.data.data.rows;
					for (let i = 0; i < skuList.length; i++) {
						store.state.allSkus[skuList[i].id] = skuList[i].cover;
					}
				}
			});
		}).catch(err => {
			console.log(err);
			this.$Message.error(err);
		});
	},
	// 查询所有供应商
	initAllSupplier(context) {
		return new Promise((resolve, reject) => {
			querySupplierList({rows: 1000}).then(res => {
				if (res.status === 200) {
					store.state.allSuppliers = res.data.data.rows;
				}
			});
		}).catch(err => {
			console.log(err);
			this.$Message.error(err);
		});
	},
	initPage(context, param) {
		queryAdminConfig({}).then(data => {
			if (data.data.code == 1200) {
				context.commit("initPage", data.data.data);
			}
		}).catch(err => {
			console.log(err);
		});
	},
	// 查询称重框
	queryTurnoverBoxList(context, param) {
		queryTurnoverBoxList({rows: 100, box_type: 2}).then(res => {
			if (res.status === 200) {
				let turnoverList = res.data.data.rows;
				/*for (let i = 0; i < turnoverList.length; i++) {
					let weight = changeUnit(turnoverList[i].box_weight, "g", "斤") + "斤";
					turnoverList[i].title += "(" + weight + ")";
				}*/
				if (res.data.code == 1200) {
					context.commit("initTurnoverBoxs", turnoverList);
				}
			}
		});
	},
	// 查询分拣时间
	getDeliverySetting(context, param) {
		queryDeliverySetting({}).then(data => {
			if (data.data.code == 1200) {
				if (!data.data.data) {
					return context.commit("initSortingTime", null);
				}
				// let setting = JSON.parse(data.data.data.value);
				// let sortingTimes = setting.sortingTimes;
				// if (sortingTimes) {
				context.commit("initSortingTime", data.data.data);
				// }
			}
		}).catch(err => {
			console.log(err);
		});
	},
	// 查询运营时间
	queryOperationList(context, param) {
		queryOperationList({}).then(data => {
			if (data.data.code == 1200) {
				// if (!data.data.data) {
				// 	return context.commit("initOperationTime", null);
				// }
				// let setting = JSON.parse(data.data.data.value);
				// let sortingTimes = setting.sortingTimes;
				// if (sortingTimes) {
				context.commit("initOperationTime", data.data.data.rows);
				// }
			}
		}).catch(err => {
			console.log(err);
		});
	}
}





// WEBPACK FOOTER //
// ./src/store/actions/initAdminAction.js